module.exports = __webpack_public_path__ + "static/media/rhomb-footer-pattern.1527ef82.svg";